import {InfoOutlined as InfoIcon} from '@material-ui/icons';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';
import {Typography} from '@material-ui/core';

export default function InfoTooltip(props)
{   const {tooltipText} = props;
    return (
        <Tooltip title={<Typography>{tooltipText}</Typography>}>
            <InfoIcon id="infoIcon"/>
        </Tooltip>
    );
}

InfoTooltip.propTypes = {
    tooltipText: PropTypes.string.isRequired
};